var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserlistIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 74 74",
    height: 74,
    viewBox: "0 0 74 74",
    width: 74,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m59.1 71h-44.2c-3.3 0-6-2.7-6-6v-56c0-3.3 2.7-6 6-6h44.2c3.3 0 6 2.7 6 6v56c0 3.3-2.7 6-6 6z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m33.7 14.1-9.8 8.8-4.8-4.4",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m37 22.1h17.9",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m33.7 31.8-9.8 8.7-4.8-4.3",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m37 39.7h17.9",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m19.1 57.4h35.8",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    display: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m59.1 1h-44.2c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h44.2c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-41.5 16.2c.7-.8 2-.9 2.8-.2l3.5 3.2 8.4-7.5c.8-.7 2.1-.7 2.8.2.7.8.7 2.1-.2 2.8l-9.8 8.7c-.4.3-.9.5-1.3.5s-1-.2-1.3-.5l-4.8-4.4c-.8-.7-.9-2-.1-2.8zm0 17.6c.7-.8 2-.9 2.8-.2l3.5 3.2 8.4-7.5c.8-.7 2.1-.7 2.8.2.7.8.7 2.1-.2 2.8l-9.7 8.7c-.4.3-.9.5-1.3.5s-1-.2-1.3-.5l-4.9-4.4c-.8-.7-.9-2-.1-2.8zm37.3 24.6h-35.8c-1.1 0-2-.9-2-2s.9-2 2-2h35.9c1.1 0 2 .9 2 2s-1 2-2.1 2zm0-17.7h-17.9c-1.1 0-2-.9-2-2s.9-2 2-2h17.9c1.1 0 2 .9 2 2s-.9 2-2 2zm0-17.6h-17.9c-1.1 0-2-.9-2-2s.9-2 2-2h17.9c1.1 0 2 .9 2 2s-.9 2-2 2z",
    display: "inline"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m59.1 73h-44.2c-4.4 0-8-3.6-8-8v-56c0-4.4 3.6-8 8-8h44.2c4.4 0 8 3.6 8 8v56c0 4.4-3.6 8-8 8zm-44.2-68c-2.2 0-4 1.8-4 4v56c0 2.2 1.8 4 4 4h44.2c2.2 0 4-1.8 4-4v-56c0-2.2-1.8-4-4-4z",
    fill: "#789a98"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m23.9 24.9c-.5 0-1-.2-1.3-.5l-4.9-4.4c-.8-.7-.9-2-.2-2.8s2-.9 2.8-.2l3.5 3.2 8.4-7.5c.8-.7 2.1-.7 2.8.2.7.8.7 2.1-.2 2.8l-9.8 8.7c-.1.3-.6.5-1.1.5z",
    fill: "#ececec"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m54.9 24.1h-17.9c-1.1 0-2-.9-2-2s.9-2 2-2h17.9c1.1 0 2 .9 2 2s-.9 2-2 2z",
    fill: "#ececec"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m23.9 42.5c-.5 0-1-.2-1.3-.5l-4.9-4.4c-.8-.7-.9-2-.2-2.8s2-.9 2.8-.2l3.5 3.2 8.4-7.5c.8-.7 2.1-.7 2.8.2.7.8.7 2.1-.2 2.8l-9.6 8.7c-.3.3-.8.5-1.3.5z",
    fill: "#ececec"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m54.9 41.7h-17.9c-1.1 0-2-.9-2-2s.9-2 2-2h17.9c1.1 0 2 .9 2 2s-.9 2-2 2z",
    fill: "#ececec"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m54.9 59.4h-35.8c-1.1 0-2-.9-2-2s.9-2 2-2h35.9c1.1 0 2 .9 2 2s-1 2-2.1 2z",
    fill: "#ececec"
  }))))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    display: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m59.1 1h-44.2c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h44.2c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-41.5 16.2c.7-.8 2-.9 2.8-.2l3.5 3.2 8.4-7.5c.8-.7 2.1-.7 2.8.2.7.8.7 2.1-.2 2.8l-9.8 8.7c-.4.3-.9.5-1.3.5s-1-.2-1.3-.5l-4.8-4.4c-.8-.7-.9-2-.1-2.8zm0 17.6c.7-.8 2-.9 2.8-.2l3.5 3.2 8.4-7.5c.8-.7 2.1-.7 2.8.2.7.8.7 2.1-.2 2.8l-9.7 8.7c-.4.3-.9.5-1.3.5s-1-.2-1.3-.5l-4.9-4.4c-.8-.7-.9-2-.1-2.8zm37.3 24.6h-35.8c-1.1 0-2-.9-2-2s.9-2 2-2h35.9c1.1 0 2 .9 2 2s-1 2-2.1 2zm0-17.7h-17.9c-1.1 0-2-.9-2-2s.9-2 2-2h17.9c1.1 0 2 .9 2 2s-.9 2-2 2zm0-17.6h-17.9c-1.1 0-2-.9-2-2s.9-2 2-2h17.9c1.1 0 2 .9 2 2s-.9 2-2 2z",
    display: "inline",
    fill: "#ececec"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserlistIcon);
export default __webpack_public_path__ + "static/media/userlist-icon.c229a759ec4e87f3661aa9319de6616a.svg";
export { ForwardRef as ReactComponent };